import { createReducer, on } from '@ngrx/store';
import * as fromFoldActions from '../actions/folds.actions';
import { FoldFirebaseResponse } from '../../models/folds.model';

export interface FoldsState {
    data: FoldFirebaseResponse;
    loaded: boolean;
    loading: boolean;
    error: string;
}

export const initialState: FoldsState = {
    data: undefined as any,
    loaded: false,
    loading: false,
    error: ''
};

export const foldsReducer = createReducer(
    initialState,
    on(fromFoldActions.LoadFoldAction, (state) => ({ ...state, loading: true })),
    on(fromFoldActions.LoadFoldSuccessAction, (state, { data }) => ({ ...state, data, loaded: true, loading: false })),
    on(fromFoldActions.LoadFoldFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromFoldActions.AddFoldAction, (state) => ({ ...state, loading: true })),
    on(fromFoldActions.AddFoldSuccessAction, (state, { data }) => ({ ...state, data, loaded: true, loading: false })),
    on(fromFoldActions.AddFoldFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromFoldActions.UpdateFoldAction, (state) => ({ ...state, loading: true })),
    on(fromFoldActions.UpdateFoldSuccessAction, (state, { data }) => ({ ...state, data: { ...state.data, registers: data.registers }, loaded: true, loading: false })),
    on(fromFoldActions.UpdateFoldFailAction, (state, { error }) => ({ ...state, error: error.message })),
);
